import React from "react";
import { withRouter } from "react-router-dom";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import ErrorBoundary from "./ErrorBoundary";
import Button from "./utilities/Button";
import loading from "../img/loading.svg";
import ContentLoader from "react-content-loader";
import Select from "react-select";
import update from "immutability-helper";
import bcrypt from "bcryptjs";

class CreateUser extends React.Component {
  constructor(props) {
    super();

    this.state = {
      email: "",
      name: "",
      selectedUser: null,
      loading: false,
      loadingD: false,
      error: false,
      confirm: false,
      isDoctor: false,
      password: null,
      emailSubscription: false
    };
  }
  toggleConfirm = () => {
    this.setState({ confirm: !this.state.confirm });
  };
  handleIsDoctor = event => {
    let role = "SECRETARY";
    if (event.target.checked) {
      role = "DOCTOR";
    }
    let newState = update(this.state, {
      selectedUser: {
        role: { $set: role }
      }
    });
    this.setState(newState);
  };

  handleChangeUser = user => {
    this.setState({
      selectedUser: user
    });
  };
  componentWillReceiveProps(props) {
    if (props.refetch) {
      props.getAllUsers.refetch();
      props.setRefetch(false);
    }
  }
  deleteSelectedUser = () => {
    this.setState({
      loadingD: true
    });

    if (this.state.selectedUser.week) {
      let id = this.state.selectedUser.week.id;
      this.props
        .deleteWeekMutation({
          variables: { id }
        })
        .then(() => {
          id = this.state.selectedUser.id;
          this.props
            .deleteUserMutation({
              variables: { id }
            })
            .then(() => {
              this.setState(
                { loadingD: false, selectedUser: null },
                this.props.getAllUsers.refetch
              );
              this.toggleConfirm();
            });
        })
        .catch(e => {
          this.setState({ loadingD: false, error: true });
          console.error("delete slot", e);
        });
    } else {
      let id = this.state.selectedUser.id;
      this.props
        .deleteUserMutation({
          variables: { id }
        })
        .then(() => {
          this.setState(
            { loading: false, selectedUser: null },
            this.props.getAllUsers.refetch
          );
        })
        .catch(e => {
          this.setState({ loading: false, error: true });
          console.error("delete slot", e);
        });
    }
  };
  handleSubmit = e => {
    e.preventDefault();
    const id = this.state.selectedUser.id;
    const role = this.state.selectedUser.role;
    let pass = this.state.password;
    const email = this.state.selectedUser.email;
    const name = this.state.selectedUser.name;
    this.setState({
      loading: true
    });

    if (pass && pass.length > 0) {
      const SALT_ROUNDS = 10;
      const salt = bcrypt.genSaltSync(SALT_ROUNDS);
      pass = bcrypt.hash(pass, salt).then(password => {
        this.props
          .updateUserMutationWithPassword({
            variables: { id, name, email, password, role }
          })
          .then(() => {
            this.setState(
              { loading: false, selectedUser: null },
              this.props.getAllUsers.refetch
            );
          })
          .catch(e => {
            this.setState({ loading: false, error: true });
            console.error("update user", e);
          });
      });
    } else {
      this.props
        .updateUserMutation({
          variables: { id, name, email, role }
        })
        .then(() => {
          this.setState(
            { loading: false, selectedUser: null },
            this.props.getAllUsers.refetch
          );
        })
        .catch(e => {
          this.setState({ loading: false, error: true });
          console.error("update user", e);
        });
    }
  };
  render() {
    if (this.props.getAllUsers.loading) {
      return (
        <div className="column is-4">
          <div className="card">
            <header className="card-header">
              <h1 className="card-header-title has-text-centered is-size-3">
                Editer un utilisateur
              </h1>
            </header>
            <div className="card-content  has-text-left">
              <ContentLoader type="facebook" />
            </div>
          </div>
        </div>
      );
    }

    return (
      <ErrorBoundary>
        <div className="column is-4">
          <div className="card">
            <header className="card-header">
              <h1 className="card-header-title has-text-centered is-size-3">
                Editer un utilisateur
              </h1>
            </header>
            <header className="card-header">
              <div className="card-header-title has-text-centered is-size-12">
                <Select
                  name="form-field-name"
                  placeholder="Sélectionnez un utilisateur"
                  value={this.state.selectedUser}
                  options={this.props.getAllUsers.allUsers}
                  labelKey="name"
                  valueKey="id"
                  clearable={false}
                  wrapperStyle={{ width: "100%" }}
                  onChange={v => this.handleChangeUser(v)}
                />
              </div>
            </header>
            <div className="card-content  has-text-left">
              {this.state.selectedUser ? (
                <form
                  onSubmit={this.handleSubmit}
                  style={{ position: "relative" }}
                >
                  {this.state.confirm ? (
                    <div className="modal-slot-overlay">
                      <div className="modal-slot-overlay-content has-text-centered">
                        <h1 className="title">Êtes-vous sûr?</h1>
                        <p>
                          <Button
                            style={{
                              width: "100px"
                            }}
                            text="Retour"
                            onClick={this.toggleConfirm}
                          />
                          <Button
                            color="red"
                            text="Oui!"
                            onClick={this.deleteSelectedUser}
                            style={{
                              width: "100px"
                            }}
                          />
                        </p>
                        {this.state.loadingD ? (
                          <figure className="image is-32x32">
                            <img alt="loading" src={loading} />
                          </figure>
                        ) : null}
                      </div>
                    </div>
                  ) : null}
                  <div className="field">
                    <label className="label">Email</label>
                    <div className="control">
                      <input
                        className={`input ${this.state.error
                          ? "is-danger"
                          : ""}`}
                        type="email"
                        value={this.state.selectedUser.email}
                        onChange={e => {
                          let newState = update(this.state, {
                            selectedUser: {
                              email: { $set: e.target.value }
                            }
                          });
                          this.setState(newState);
                        }}
                      />
                    </div>
                  </div>
                  <div className="field">
                    <label className="label">Nom</label>
                    <div className="control">
                      <input
                        className={`input ${this.state.error
                          ? "is-danger"
                          : ""}`}
                        type="text"
                        value={this.state.selectedUser.name}
                        placeholder="Dr. Machin"
                        onChange={e => {
                          let newState = update(this.state, {
                            selectedUser: {
                              name: { $set: e.target.value }
                            }
                          });
                          this.setState(newState);
                        }}
                      />
                    </div>
                  </div>
                  <div className="field">
                    <label className="checkbox">
                      <input
                        type="checkbox"
                        onChange={this.handleIsDoctor}
                        checked={
                          this.state.selectedUser.role === "DOCTOR" ? (
                            true
                          ) : (
                            false
                          )
                        }
                      />{" "}
                      est un médecin
                    </label>
                  </div>
                  <div className="field">
                    <label className="label">Nouveau mot de passe</label>
                    <div className="control">
                      <input
                        className={`input  ${this.state.error
                          ? "is-danger"
                          : ""}`}
                        type="password"
                        onChange={e =>
                          this.setState({ password: e.target.value })}
                      />
                    </div>
                  </div>
                  <div className="field  has-text-centered">
                    {this.state.loading ? (
                      <figure
                        style={{
                          marginBottom: "-10px"
                        }}
                        className="image is-32x32"
                      >
                        <img alt="loading" src={loading} />
                      </figure>
                    ) : null}
                    <Button
                      text="Effacer"
                      type="button"
                      color="red"
                      onClick={this.toggleConfirm}
                      disabled={this.state.loading}
                    />
                    <Button
                      text="Sauvegarder"
                      type="submit"
                      disabled={this.state.loading}
                    />
                  </div>
                </form>
              ) : null}
            </div>
          </div>
        </div>
      </ErrorBoundary>
    );
  }
}

const GET_ALL_USERS_QUERY = gql`
  query {
    allUsers(filter: { role_not: ADMIN }) {
      id
      name
      email
      role
      week {
        id
      }
    }
  }
`;
const DELETE_USER = gql`
  mutation deleteUserMutation($id: ID!) {
    deleteUser(id: $id) {
      id
    }
  }
`;
const DELETE_WEEK = gql`
  mutation deleteWeekMutation($id: ID!) {
    deleteWeek(id: $id) {
      id
    }
  }
`;
const UPDATE_USER_PASSWORD = gql`
  mutation updateUserMutationPassword(
    $id: ID!
    $name: String
    $role: Role
    $email: String
    $password: String
  ) {
    updateUser(
      id: $id
      name: $name
      role: $role
      email: $email
      password: $password
    ) {
      id
    }
  }
`;
const UPDATE_USER = gql`
  mutation updateUserMutation(
    $id: ID!
    $name: String
    $role: Role
    $email: String
  ) {
    updateUser(id: $id, name: $name, role: $role, email: $email) {
      id
    }
  }
`;

export default compose(
  graphql(GET_ALL_USERS_QUERY, {
    name: "getAllUsers",
    fetchPolicy: "network-only"
  }),
  graphql(DELETE_USER, {
    name: "deleteUserMutation"
  }),
  graphql(DELETE_WEEK, {
    name: "deleteWeekMutation"
  }),
  graphql(UPDATE_USER, {
    name: "updateUserMutation"
  }),
  graphql(UPDATE_USER_PASSWORD, {
    name: "updateUserMutationWithPassword"
  })
)(withRouter(CreateUser));



// WEBPACK FOOTER //
// ./src/components/EditUser.js